export default __webpack_public_path__ + "static/media/icon_venues_bw.bd98e9e4.svg";